<template>
  <a v-if="contentInfo" @click.prevent="goToContentDetail()" href="#">
    <div class="con-img">
      <div class="picture-area">
        <WebpImage :imageInfo="{ imageUrl: image, width: 185, height: 278, alt: title }" />
      </div>
    </div>
    <span class="con-text-wrap">
      <strong class="event-con-tit">{{ title }}</strong>

      <!--      movie 장르-->
      <span v-if="!isVod && hasGenres" class="event-con-text01 event-td-one">
        {{ genres }} <template v-if="playTime"><span class="title-dot" /> {{ playTime }}</template>
      </span>

      <template v-for="(tr, index) in tableList">
        <span
          v-if="tr.isShow"
          :key="index"
          class="event-tr"
        >
        <strong class="event-th">{{ tr.title }}</strong>
        <span :class="[`event-td`, `event-td-${tr.key === 'synopsis' ? 'five' : 'one'}`]">
          {{ tr.value }}
        </span>
      </span>
      </template>
    </span>
  </a>
</template>

<script>
import { addPostfixAndUrl } from '@/common/utils/common'
import { PATH_NAME_PLAYER_VOD, PATH_NAME_PLAYER_MOVIE } from '@/common/resources/router.const'
import WebpImage from '@/components/image/WebpImage.vue'

export default {
  components: { WebpImage },
  props: {
    contentInfo: {
      type: Object,
      default: null
    },
    contentType: {
      type: String, // 'movie | vod
      default: ''
    }
  },
  filters: {
    addPostfixAndUrl
  },
  computed: {
    actor () {
      return (this.contentInfo?.actor ?? '').replaceAll(/,(?=\S)/gi, ', ')
    },
    director () {
      return (this.contentInfo?.director ?? '').replaceAll(/,(?=\S)/gi, ', ')
    },
    genres () {
      return (this.contentInfo?.genres ?? '').replaceAll(/,(?=\S)/gi, ', ')
    },
    image () {
      return this.contentInfo?.image ?? ''
    },
    imgAlt () {
      return this.contentInfo?.title ?? ''
    },
    movieId () {
      return this.contentInfo?.movieid ?? ''
    },
    playTime () {
      return this.contentInfo.playtime ? `${Math.ceil(this.contentInfo.playtime / 60)}분` : ``
    },
    programId () {
      return this.contentInfo.programid ?? ''
    },
    releaseDate () {
      return this.contentInfo?.releasedate ?? ''
    },
    synopsis () {
      return this.contentInfo?.synopsis ?? ''
    },
    targetAge () {
      return this.contentInfo?.targetage ?? ''
    },
    title () {
      return this.contentInfo?.title ?? ''
    },
    isVod () {
      return this.contentType === 'vod'
    },
    hasActor () {
      return this.actor !== ''
    },
    hasDirector () {
      return this.director !== ''
    },
    hasGenres () {
      return this.genres !== ''
    },
    hasReleaseDate () {
      return this.releaseDate !== ''
    },
    hasSynopsis () {
      return this.synopsis !== ''
    },
    tableList () {
      const vod = [
        { title: '장르', key: 'genres', value: this.genres, isShow: this.hasGenres },
        { title: '감독', key: 'director', value: this.director, isShow: this.hasDirector },
        { title: '출연진', key: 'actor', value: this.actor, isShow: this.hasActor },
        { title: '줄거리', key: 'synopsis', value: this.synopsis, isShow: this.hasSynopsis }
      ]
      const movie = [
        { title: '감독', key: 'director', value: this.director, isShow: this.hasDirector },
        { title: '출연진', key: 'actor', value: this.actor, isShow: this.hasActor },
        { title: '개봉일', key: 'releaseDate', value: this.releaseDate, isShow: this.hasReleaseDate },
        { title: '줄거리', key: 'synopsis', value: this.synopsis, isShow: this.hasSynopsis }
      ]
      return this.isVod ? vod : movie
    }
  },
  methods: {
    goToContentDetail () {
      const query = this.isVod ? { programid: this.programId } : { movieid: this.movieId }

      this.$router.push({
        name: this.isVod ? PATH_NAME_PLAYER_VOD : PATH_NAME_PLAYER_MOVIE,
        query: query
      })
    }
  }
}
</script>
